module.exports = __webpack_public_path__ + "img/circle-green-icon.6018cb64.svg";